import { createRoomOptions } from './room-options';

import { Room } from 'livekit-client';

let preparedRoom = null;

export const prepareRoom = ({ url, token, options }) => {
	if (preparedRoom) {
		return preparedRoom;
	}

	preparedRoom = new Room(createRoomOptions(options));

	preparedRoom.prepareConnection(url, token).catch(() => {});

	return preparedRoom;
};

export const takePreparedRoom = () => {
	const room = preparedRoom;

	preparedRoom = null;

	return room;
};

export const discardPreparedRoom = () => {
	takePreparedRoom()?.disconnect().catch(() => {});
};
